import { Injectable } from "@angular/core";
import { RESPONSE_ERROR_CODES } from "../constant/response-error-codes.constant";

@Injectable()
export class ResponseMessageService {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    getMessage(responseError: any) {
        const errorCode = responseError.errorContent?.error || responseError.status;
        return RESPONSE_ERROR_CODES[errorCode] || RESPONSE_ERROR_CODES.unhandledError;
    }
}
